<template>
  <v-container class="px-0 pt-0 pb-0" fluid>
    <v-row v-if="!invoice">
      <v-col cols="12" class="pt-0 pb-0">
        <v-checkbox
          class="pt-0 pb-0"
          v-model="invoiceRequest"
          :label="$t('common.invoice')"
        ></v-checkbox>
      </v-col>
    </v-row>
    <template v-if="invoiceRequest || invoice">
      <v-row>
        <v-col cols="12" class="pt-0 pb-0 d-flex">
          <v-text-field
            name="name"
            type="text"
            v-model="company.name"
            :label="$t('common.companyName')"
            :rules="rules.name"
            hide-details="auto"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="d-flex pt-0 pb-0">
          <v-text-field
            :rules="rules.nif"
            hide-details="auto"
            v-model="company.nif"
            label="NIF"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="d-flex pt-0 pb-0">
          <v-text-field
            :rules="rules.postal_code"
            hide-details="auto"
            v-model="company.postal_code"
            :label="$t('common.postalCode')"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="d-flex pt-0 pb-0">
          <v-text-field
            :rules="rules.city"
            hide-details="auto"
            v-model="company.city"
            :label="$t('common.town')"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="d-flex pt-0 pb-0">
          <v-textarea
            :rules="rules.address"
            hide-details="auto"
            name="input-7-1"
            v-model="company.address"
            :label="$t('common.address')"
            rows="2"
          ></v-textarea>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "Factura",
  props: ["invoice"],
  data() {
    return {
      invoiceRequest: false,
      company: {
        name: "",
        address: "",
        nif: "",
        postal_code: null,
        city: ""
      },
      rules: {
        name: [v => !!v || this.$t("common.nameIsRequired")],
        address: [v => !!v || this.$t("common.addressIsRequired")],
        nif: [v => !!v || this.$t("common.NIFIsRequired")],
        postal_code: [v => !!v || this.$t("common.postalCodeIsRequired")],
        city: [v => !!v || this.$t("common.cityIsRequired")]

        // value => !!value || 'Required.',
        // value => (value && value.length >= 3) || 'Min 3 characters',
      }
    };
  }
};
</script>

<style scoped lang="scss"></style>
